import { FollowUpModel, QqFollowUpModel } from '@mm/state/model/FollowUpModel';

const UIFilterAutomationRuleKind = [
  'lead_assignments',
  'follow_ups',
  'business_hours',
  'system_messages',
] as const;

type UIFilterAutomationRuleKindTuple = typeof UIFilterAutomationRuleKind;
export type UIFilterAutomationRuleKindType =
  UIFilterAutomationRuleKindTuple[number];

export function isAutomationKind(s: any): s is UIFilterAutomationRuleKindType {
  return UIFilterAutomationRuleKind.includes(s);
}

export const automationTypeByKind: Record<
  UIFilterAutomationRuleKindType,
  { name: string }
> = {
  lead_assignments: {
    name: 'Lead Assignments',
  },
  follow_ups: {
    name: 'Automatic Follow Up',
  },
  business_hours: {
    name: 'Business Hours',
  },
  system_messages: {
    name: 'System Messages',
  },
};

export type AutomationRulesMapType = {
  followUps: FollowUpModel<QqFollowUpModel>;
};
